import styled, { css } from 'styled-components';

export const LocationsContainer = styled.div<{ $loading: boolean }>`
  height: 100%;
  overflow: scroll;
  padding: 15px;
  padding-bottom: 90px;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }

  ${({ $loading }) =>
    $loading &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0;
    padding-bottom: 120px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 0;
    padding-bottom: 120px;
  }
`;

export const modalFooterStyles = css`
  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    justify-content: center;
    button {
      width: 50%;
    }
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    justify-content: flex-end;
    button {
      &:first-of-type {
        width: 193px;
      }
      &:last-of-type {
        width: 334px;
      }
    }
  }
`;
